import { getContext } from '@fiverr-private/fiverr_context';
import { localStorage } from '@fiverr-private/futile';

const buildKey = (userId) => `ENCOURAGE_SELLER_REPLY_${userId}`;

export const readState = () => {
    const { userId } = getContext();
    const state = localStorage.get(buildKey(userId));

    return state || {};
};

export const persistState = (state) => {
    const { userId } = getContext();

    localStorage.set(buildKey(userId), state);
};
